// project imports
import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import SidebarSearch from './SidebarSearch';
import { useGetMenuMaster } from 'api/menu';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  return (
    <>
      {/* autoHide={false}: scrollbar hamesha dikhe (sab company types ke liye) */}
      {/* className="sidebar-simplebar": style.css ke global hide rule se sirf sidebar ko bachata he */}
      <SimpleBar
        className="sidebar-simplebar"
        autoHide={false}
        sx={{
          '& .simplebar-content': { display: 'flex', flexDirection: 'column' },

          // scrollbar track
          '& .simplebar-track.simplebar-vertical': {
            width: 8,
            right: 1,
            backgroundColor: 'transparent'
          },

          // scrollbar thumb: 6px chauda, hamesha visible (rang page ke scrollbar jaisa)
          '& .simplebar-scrollbar:before': {
            left: 1,
            right: 1,
            opacity: 1,
            borderRadius: '5px',
            background: '#a0a0a0'
          },
          '& .simplebar-scrollbar.simplebar-visible:before': {
            opacity: 1
          },
          '& .simplebar-scrollbar:hover:before': {
            background: '#6e6e6e'
          }
        }}
      >
        <SidebarSearch menuData={{ items: menuItem.items }} drawerOpen={drawerOpen} />
        <Navigation />
        {/* {drawerOpen && <NavCard />} */}
      </SimpleBar>
    </>
  );
}